import React, { useState } from 'react';
import { GIFTS } from '../giftAnimations';

/*
  GiftPicker — the gift tray. Shows the catalog by tier, a quantity/combo
  selector (×1/5/10/99/999/Custom), and a Send button. Calls onSend(giftId, qty).
  Icons come from each gift's thumb() (an HTML string).
*/
const TIERS = [
  { key: 'pocket', label: 'Pocket' },
  { key: 'mini', label: 'Minis' },
  { key: 'classic', label: 'Classics' },
  { key: 'premium', label: 'Premium' },
  { key: 'legend', label: 'Legendary' },
];
const QTYS = [1, 5, 10, 99, 999];

function chipStyle(active) {
  return {
    border: active ? '1px solid #34E3A4' : '1px solid rgba(255,255,255,.14)',
    background: active ? '#34E3A4' : 'rgba(255,255,255,.05)',
    color: active ? '#062015' : '#EAF1F5',
    borderRadius: 999, padding: '6px 12px', fontSize: 13, fontWeight: 700, cursor: 'pointer',
  };
}

export default function GiftPicker({ onSend, onClose, emeralds = 0 }) {
  const [sel, setSel] = useState(null);
  const [qty, setQty] = useState(1);
  const total = sel ? sel.price * qty : 0;

  return (
    <div
      style={{ background: '#0E141C', border: '1px solid rgba(255,255,255,.1)', borderRadius: 16, overflow: 'hidden', color: '#EAF1F5' }}
      data-testid="gift-picker"
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 14px', borderBottom: '1px solid rgba(255,255,255,.08)' }}>
        <div style={{ fontWeight: 800, fontSize: 15 }}>Send a Gift</div>
        <div style={{ fontSize: 12.5, color: '#8A97A6' }}>Balance: <b style={{ color: '#F5D67A' }}>{emeralds.toLocaleString()}</b> Emeralds</div>
      </div>

      <div style={{ maxHeight: '52vh', overflowY: 'auto', padding: 14 }}>
        {TIERS.map((t) => {
          const items = GIFTS.filter((g) => g.tier === t.key);
          if (!items.length) return null;
          return (
            <div key={t.key} style={{ marginBottom: 14 }}>
              <div style={{ fontSize: 12, fontWeight: 800, letterSpacing: '.14em', textTransform: 'uppercase', color: '#8A97A6', margin: '4px 2px 8px' }}>{t.label}</div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(84px,1fr))', gap: 8 }}>
                {items.map((g) => (
                  <button
                    key={g.id}
                    onClick={() => setSel(g)}
                    style={{
                      background: sel && sel.id === g.id ? 'rgba(52,227,164,.15)' : 'rgba(255,255,255,.03)',
                      border: sel && sel.id === g.id ? '1px solid #34E3A4' : '1px solid rgba(255,255,255,.08)',
                      borderRadius: 12, padding: '10px 6px', cursor: 'pointer', textAlign: 'center', color: '#EAF1F5',
                    }}
                    data-testid={`gift-option-${g.id}`}
                  >
                    <div style={{ height: 44, display: 'flex', alignItems: 'center', justifyContent: 'center' }} dangerouslySetInnerHTML={{ __html: g.thumb() }} />
                    <div style={{ fontSize: 11.5, fontWeight: 600, marginTop: 4, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{g.name}</div>
                    <div style={{ fontSize: 11, color: '#F5D67A', fontWeight: 800 }}>{g.price.toLocaleString()}</div>
                  </button>
                ))}
              </div>
            </div>
          );
        })}
      </div>

      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8, padding: '10px 14px', borderTop: '1px solid rgba(255,255,255,.1)' }}>
        {QTYS.map((q) => (
          <button key={q} onClick={() => setQty(q)} style={chipStyle(q === qty)}>×{q.toLocaleString()}</button>
        ))}
        <button
          onClick={() => { let v; try { v = parseInt(prompt('Enter amount to send:', '50'), 10); } catch (e) { v = null; } if (v && v > 0) setQty(Math.min(v, 999999)); }}
          style={chipStyle(!QTYS.includes(qty))}
        >Custom</button>
        <button
          disabled={!sel}
          onClick={() => sel && onSend && onSend(sel.id, qty)}
          style={{
            marginLeft: 'auto', background: 'linear-gradient(90deg,#34E3A4,#22C98C)', color: '#062015',
            fontWeight: 800, border: 'none', borderRadius: 999, padding: '11px 20px',
            cursor: sel ? 'pointer' : 'not-allowed', opacity: sel ? 1 : 0.5, whiteSpace: 'nowrap',
          }}
          data-testid="gift-send"
        >
          {sel ? `Send ${total.toLocaleString()}` : 'Pick a gift'}
        </button>
      </div>
    </div>
  );
}
